import { useLanguageData } from '@/common/hooks/useLanguageData';
import { LoungeMood, SurpriseAction } from '../../home.styles';

const SurpriseSparkleIcon = () => (
	<span aria-hidden="true">
		<svg viewBox="0 0 24 24">
			<path d="m12 3 1.6 5.4L19 10l-5.4 1.6L12 17l-1.6-5.4L5 10l5.4-1.6L12 3Z" />
			<path d="m18 15 .7 2.3L21 18l-2.3.7L18 21l-.7-2.3L15 18l2.3-.7L18 15Z" />
		</svg>
	</span>
);

const HomeLoungeMood = ({ onSurprise }) => {
	const t = useLanguageData('home');

	return (
		<LoungeMood aria-label={t.loungeHighlight}>
			<div>
				<h2>
					{t.loungeTitlePrefix} <span>{t.loungeTitleSoftie}</span>
					{t.loungeTitleMiddle} <span>{t.loungeTitleVibe}</span>
				</h2>
			</div>
			<SurpriseAction type="button" onClick={onSurprise}>
				<SurpriseSparkleIcon />
				{t.surpriseMe}
			</SurpriseAction>
		</LoungeMood>
	);
};

export default HomeLoungeMood;
